import auth from '@/middleware/modules/auth'

const FeedsIndex = () => import(/* webpackChunkName: "_v-feeds" */ '@/views/feeds/FeedsIndex.vue')
const FeedEdit = () => import(/* webpackChunkName: "_v-feeds" */ '@/views/feeds/FeedEdit.vue')
const FeedView = () => import(/* webpackChunkName: "_v-feeds" */ '@/views/feeds/FeedView.vue')

export default [
  {
    path: 'feeds',
    name: 'feeds',
    props: (route) => ({ querySearch: route.query.search }),
    component: FeedsIndex,
    meta: {
      layout: 'app-layout',
      middleware: [auth],
    },
  },
  {
    path: 'feed/new',
    name: 'feed-new',
    component: FeedEdit,
    meta: {
      layout: 'app-layout',
      middleware: [auth],
      breadcrumbs: ['feeds'],
    },
  },
  {
    path: 'feed/:id(\\d+)',
    name: 'feed-view',
    props: (route) => ({
      embedID: parseInt(route.params.id),
      querySearch: route.query.search,
      feedSort: route.query.sort,
    }),
    component: FeedView,
    meta: {
      layout: 'app-layout',
      middleware: [auth],
      breadcrumbs: ['feeds'],
    },
  },
  {
    path: 'feed/:id(\\d+)/edit',
    name: 'feed-edit',
    component: FeedEdit,
    meta: {
      layout: 'app-layout',
      middleware: [auth],
      breadcrumbs: ['feeds'],
    },
  },
]
